import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio169: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconAspectRatio169"><Path d="M3.5 5C2.11929 5 1 6.11929 1 7.5V16.5C1 17.8807 2.11929 19 3.5 19H20.5C21.8807 19 23 17.8807 23 16.5V7.5C23 6.11929 21.8807 5 20.5 5H3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio169;
